import React from 'react';
import { Card, CardMedia, useTheme } from '@mui/material';
import imgPlaceholder from '../../assets/images/my_day_placeholder_card.png';

const MyDayPlaceholderCard = () => {
  const theme = useTheme();

  return (
    <Card
      className="my-day-compact-content-card"
      style={{ backgroundColor: theme.palette.primary.loadingCardBackground }}
      sx={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ height: '144px', display: 'flex' }}>
        <CardMedia
          sx={{ height: '123px', width: '123px', margin: 'auto' }}
          image={imgPlaceholder}
        />
      </div>
    </Card>
  );
};

export default MyDayPlaceholderCard;
